import { useSelector } from 'react-redux';
import { useBlocker } from 'hooks/useBlocker';
import { MIXPANEL_WIZARD_STEP_MAP } from './constants';
import { createWarnOnStepChangeSelector } from './selectors';
import { VideoFlowStep } from './types';

export default function useVideoFlowBlocker(stepId: VideoFlowStep) {
  const shouldWarn = useSelector(createWarnOnStepChangeSelector(stepId));

  return useBlocker(shouldWarn, MIXPANEL_WIZARD_STEP_MAP[stepId]);
}
